import FormattedMessage from 'I18n/components/FormattedMessage';
import FreeProducts from 'merchandise-lib/constants/FreeProduct';
import Products from 'merchandise-lib/constants/Product';
import { useTierQueryParam } from '../../../hooks/useTierQueryParam';
import PricingPlanToggleButton from '../../components/PricingPlanToggleButton';
import { HubMerchCardLayoutUI } from '../../containers/merch-card/HubMerchCardLayoutUI';
import { CustomerPlatformFeaturesContainer } from '../../containers/merch-card/features-display/customer-platform/CustomerPlatformFeaturesContainer';
import { StarterLowerTierMessage } from '../../containers/merch-card/StarterLowerTierMessage';
import { SCREENS } from '../../constants/tracking/Screens';
import { useTabAwareProductsConfig } from '../../hooks/utilities/useTabAwareProductsConfig';
import { useIsInAppAuth } from '../../hooks/user/useUserInfo';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const productsConfig = {
  FREE: {
    Title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "merchCards.freeCard.productLevelTitle"
    }),
    HubDescription: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "merchCards.freeCard.description.operations"
    }),
    Features: /*#__PURE__*/_jsx(CustomerPlatformFeaturesContainer, {
      productLevel: "FREE",
      productApiName: FreeProducts.HUBSPOT_FREE
    })
  },
  STARTER: {
    apiName: Products.OPERATIONS_HUB_STARTER,
    Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.data.starterCard.description"
    }),
    lowerTierMessage: /*#__PURE__*/_jsx(StarterLowerTierMessage, {})
  },
  PROFESSIONAL: {
    apiName: Products.OPERATIONS_HUB_PROFESSIONAL,
    Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.data.professionalCard.description"
    }),
    lowerTierMessage: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.data.professional.lowerTierPlus"
    })
  },
  ENTERPRISE: {
    apiName: Products.OPERATIONS_HUB_ENTERPRISE,
    Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.data.enterpriseCard.description"
    }),
    lowerTierMessage: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.data.enterprise.lowerTierPlus"
    })
  }
};
export const DataHubMerchCards = () => {
  const tier = useTierQueryParam();
  const isAppAuth = useIsInAppAuth();
  const filteredProductsConfig = useTabAwareProductsConfig(productsConfig);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(HubMerchCardLayoutUI, {
      productsConfig: filteredProductsConfig,
      screen: SCREENS.DATA
    }), !isAppAuth && /*#__PURE__*/_jsx(PricingPlanToggleButton, {
      tier: tier
    })]
  });
};